export default {
    state: {
        dialogVisible: false,
        message: ''
    },
    show(message: string) {
        this.state.dialogVisible = true;
        this.state.message = message;
    },
    dismiss() {
        this.state.dialogVisible = false;
        this.state.message = '';
    }
}
